<div class="row col-12 col-sm-12 my-account-container">
  <div class="col-3 col-sm-3 col-md-3 my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'MyWarrantiesNavNode'"
    [childNavState]="'SearchWarrantyClaimNavNode'"></app-my-account-left-sidenav>
  </div>

  <div class="submit-warranty-claim col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
    <div class="my-section-box">

      @if (warrantyData$|async; as warrantyData) {
        <form [formGroup]="warrantyClaimSearchForm">
          <div class="warranty-claim-application-block">
            <h1 class="warranty-claim-headling m-0">
              {{'common.text_account_warranty_claim_search'|cxTranslate}}
            </h1>
            <div class="warranty-claim-application-detail">
              <div class="content warrantyTopText">
                <cx-page-slot position="TopContent"></cx-page-slot>
              </div>
              <div class="warranty-customID-block na-ref-cust-info-box">
                <div class="fs-wrap">
                  <div class="fs-label-wrap">
                    <label class="control-label kbclass"
                    for="claimCustomerID">{{'common.text_warranty_search_customerID'|cxTranslate}}</label>
                    @for (data of warrantyData?.b2bUnitsWSList; track data) {
                      @if (data.uid==defaultSoldTo) {
                        <div class="col-xs-12 col-sm-12 col-md-12 fs-label select-customer-id"
                          tabindex="0" (click)="showSearchResults($event)">
                          <input type="hidden" [value]="data.uid">
                          {{data?.salesArea1}}&nbsp;|&nbsp;
                          {{data?.salesArea2|cxTranslate}}&nbsp;|&nbsp;
                          {{data?.salesArea3}}
                        </div>
                        <img class="customerArrow" style="width: 20px"
                          (click)="showSearchResults($event)"
                          [src]="'/icons/arrow_down_blue.svg'" alt="">
                        }
                      }
                      @if (warrantyData?.b2bUnitsWSList) {
                        <div class="warrentCustomerID">
                          @if (showCustomerList) {
                            <app-customer-id-drop-down
                              [customerId]="warrantyData?.b2bUnitsWSList"
                              [pageSource]="'warrantyClaim'" (dataEvent)="receiveData($event)">
                            </app-customer-id-drop-down>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <div class="form-group">
                      <label class="control-label kbclass" for="warrantyPartNo">
                        {{'common.text_core_search_partnum'|cxTranslate}}
                      </label>
                      <input id="warrantyPartNo" formControlName="warrantyPartNo" class="form-control"
                        type="text" specialIsAlphaNumeric>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                      <div class="form-group">
                        <label class="control-label kbclass" for="warrantycustomerPartNo">
                          {{'common.text_warranty_search_customer_part_number'|cxTranslate}}
                        </label>
                        <input formControlName="warrantycustomerPartNo"
                          class="form-control claim-number-check" type="text" specialIsAlphaNumeric>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <div class="form-group">
                          <label class="control-label kbclass" for="warrantyClaimNo">
                            {{'common.text_warranty_search_claim_number'|cxTranslate}}
                          </label>
                          <input formControlName="warrantyClaimNo" class="form-control" type="text"
                            specialIsAlphaNumeric>
                            @if (warrantyClaimSearchForm.get('warrantyClaimNo').invalid
                              && warrantyClaimSearchForm.get('warrantyClaimNo').touched) {
                              <p class="error-message">
                              {{'common.general_required'|cxTranslate}}</p>
                            }
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                          <div class="form-group">
                            <label class="control-label kbclass"
                            for="ClaimDateFrom">{{'common.text_warranty_search_claim_from_date'|cxTranslate}}</label>
                            <input class="form-control kb-datePickerIcon warranty-datePicker"
                              formControlName="claimDateFrom" placeholder={{bsconfigDate.toLowerCase()}}
                              bsDatepicker [maxDate]="EndDate" [(ngModel)]="FromDate"
                              [bsConfig]="{ dateInputFormat: bsconfigDate.toUpperCase(),showWeekNumbers:false, displayOneMonthRange: true }">
                              <div>
                                @if ( (this.warrentyform.claimDateFrom.invalid && this.warrentyform.claimDateFrom.touched)) {
                                  <span class="text-danger-show"
                                    >
                                  {{'common.general_required'|cxTranslate}}</span>
                                }
                                @if (errorForGreaterStartDate) {
                                  <span class="text-danger-show">
                                  {{startDateErrorFromApi |cxTranslate}}</span>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                            <div class="form-group">
                              <label class="control-label kbclass"
                              for="ClaimDateTo">{{'common.text_warranty_search_claim_to_date'|cxTranslate}}</label>
                              <input class="form-control kb-datePickerIcon warranty-datePicker"
                                formControlName="claimDateTo" placeholder={{bsconfigDate.toLowerCase()}}
                                bsDatepicker [(ngModel)]="ToDate" [maxDate]="currentDate"
                                [bsConfig]="{ dateInputFormat: bsconfigDate.toUpperCase() ,showWeekNumbers:false, displayOneMonthRange: true }">
                                <div>
                                  @if ( (this.warrentyform.claimDateTo.invalid && this.warrentyform.claimDateTo.touched)) {
                                    <span class="text-danger-show"
                                      >
                                    {{'common.general_required'|cxTranslate}}</span>
                                  }
                                  @if (errorForGreaterEndDate) {
                                    <span class="text-danger-show">
                                      {{ endDateErrorFromApi |cxTranslate}}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                              <div class="form-group">
                                <label class="control-label kbclass"
                                for="warrantyClaimRefNo">{{'common.text_warranty_search_claim_ref_no'|cxTranslate}}</label>
                                <input id="warrantyClaimRefNo" formControlName="warrantyClaimRefNo"
                                  class="form-control" type="text" value="">
                                  @if (warrantyClaimSearchForm.get('warrantyClaimRefNo').invalid && warrantyClaimSearchForm.get('warrantyClaimRefNo').touched) {
                                    <p
                                    class="error-message">{{'common.general_required'|cxTranslate}}</p>
                                  }
                                </div>
                              </div>
                              @if (warrantyData?.coWorkerOrders) {
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 showRequestCheckBox"
                                  >
                                  <div class="form-group">
                                    <div class="checkbox">
                                      <label>
                                        <input type="checkbox" formControlName="showRequestsFromCoworkers">
                                        {{'common.text_Show_warranty_of_coworkers'|cxTranslate}}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                            <div class="row">
                              <div class="col-xs-12 col-sm-12 text-right">
                                <button type="button" id="WarrantyReset"
                                  class="btn btn-default WarrantyReset blue-btn" name="WarrantyReset"
                                (click)="warrantyClaimSearchForm.reset()">{{'common.text_account_reset'|cxTranslate}}</button>
                                <button type="type" class="btn  warranty-submit"
                                  id="finalSubmit"
                                  (click)="onSubmit()">{{'common.text_account_search'|cxTranslate}} <img
                                src="/icons/link-dark-grey.svg" alt="Link Icon"></button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                      @if (warrantyApiData&&!warrantyApiData?.results) {
                        <div class="row">
                          <div class="col-md-12">
                            <div class="account-section-content content-empty">
                            {{'common.text_account_warranty_search_empty'| cxTranslate}}</div>
                          </div>
                        </div>
                      }
                    }

                  </div>
                  <!-- Table -->

                  <div class="warrantCount">

                    @if (warrantyApiData?.pagination?.totalResults) {
                      <span> {{ warrantyApiData?.pagination?.totalResults }}&nbsp;</span>
                      {{'common.text_company_manageUser_registration_totalResults'|cxTranslate}}
                    }
                    @if (!warrantyApiData?.pagination?.totalResults) {
                      {{'common.text_company_manageUser_registration_zeroResults'|cxTranslate}}
                    }
                  </div>
                  <div class="WarrantyTableOuter">
                    <table class="table table-bordered table-blue order-status-table warrantySearchTable">
                      <thead>
                        <tr>
                          <th scope="col DateTh">
                            <span class="a-underline" (click)="sort('date')">
                              {{'common.text_account_warranty_table_header_date'|cxTranslate}}
                              @if (sortByDate) {
                                <span class="">&#8593;</span>
                              }
                              @if (sortByDateDesc) {
                                <span class="">&#8595;
                                </span>
                              }</span>
                            </th>
                            <th scope="col" class="warranty-search-refNo">
                              <span class="a-underline" (click)="sort('claim')">
                                {{'common.text_account_warranty_table_header_claim_number'|cxTranslate}}
                                @if (sortByClaimNumber) {
                                  <span>&#8593;</span>
                                }
                                @if (sortByClaimNumberDesc) {
                                  <span>&#8595;</span>
                                }</span>
                              </th>
                              <th scope="col" class="warranty-search-refNo">
                                <span class="a-underline" (click)="sort('status')">
                                  {{'common.text_account_warranty_table_header_claim_status'|cxTranslate}}
                                  @if (sortByStatus) {
                                    <span>&#8593;</span>
                                  }
                                  @if (sortByStatusDesc) {
                                    <span>&#8595;</span>
                                  }</span>
                                </th>
                                <th scope="col">
                                  <span class="a-underline" (click)="sort('part')">
                                    {{'common.text_core_search_partnum'|cxTranslate}}
                                    @if (sortByNumber) {
                                      <span>&#8593;</span>
                                    }
                                    @if (sortByNumberDesc) {
                                      <span>&#8595;</span>
                                    }
                                  </span>
                                </th>

                                <th scope="col">
                                  <span class="a-underline" (click)="sort('model')">
                                    {{'common.text_account_warranty_table_header_model'|cxTranslate}}
                                    @if (sortByModel) {
                                      <span>&#8593;</span>
                                    }
                                    @if (sortByModelDesc) {
                                      <span>&#8595;</span>
                                    }
                                  </span>
                                </th>

                                <th scope="col">
                                  <span class="a-underline" (click)="sort('memo')">
                                    {{'common.text_account_warranty_table_header_credit_memo'|cxTranslate}}
                                    @if (sortByMemo) {
                                      <span>&#8593;</span>
                                    }
                                    @if (sortByMemoDesc) {
                                      <span>&#8595;</span>
                                    }</span>
                                  </th>

                                  @if (warrantyApiData?.creditAmountVisible) {
                                    <th scope="col">
                                      <span class="a-underline" (click)="sort('amount')">
                                        {{ 'common.text_account_warranty_table_header_credit_amount' | cxTranslate}}
                                        @if (sortByAmount) {
                                          <span>&#8593;</span>
                                        }
                                        @if (sortByAmountDesc) {
                                          <span>&#8595;</span>
                                        }
                                      </span>
                                    </th>
                                  }
                                  <th scope="col">
                                    <span class="a-underline" (click)="sort('core')">
                                      {{'common.text_account_warranty_table_header_core_value'|cxTranslate}}
                                      @if (sortByCore) {
                                        <span>&#8593;</span>
                                      }
                                      @if (sortByCoreDesc) {
                                        <span>&#8595;</span>
                                      }
                                    </span>
                                  </th>
                                </tr>
                              </thead>
                              @if (warrantyApiData?.results) {
                                <tbody>
                                  @for (item of warrantyApiData?.results; track item) {
                                    <tr class="responsive-table-item">
                                      <td class="responsive-table-cell DateTh">
                                        <span
                                        class="d-lg-none">{{'common.text_account_warranty_table_header_date'|cxTranslate}}</span>
                                        <span>{{item?.dateString}}</span>
                                      </td>
                                      <td class="responsive-table-cell warranty-search-refNo">
                                        <span
                                        class="d-lg-none">{{'common.text_account_warranty_table_header_claim_number'|cxTranslate}}</span>
                                        <span>
                                          @if (item?.warrantyPdf) {
                                            <span class="a-underline"
                                              (click)="openDialog(item)">{{item.claimNumber}}
                                            </span>
                                          } @else {
                                            {{item.claimNumber}}
                                          }
                                        </span>
                                      </td>
                                      <td class="responsive-table-cell">
                                        <span
                                        class="d-lg-none">{{'common.text_account_warranty_table_header_claim_status'|cxTranslate}}</span>
                                        <span>{{ item.status }}</span>
                                      </td>
                                      <td class="responsive-table-cell">
                                        <span class="d-lg-none">{{'common.text_core_search_partnum'|cxTranslate}}</span>
                                        <span>{{ item.partNumber}}</span>
                                      </td>
                                      <td class="responsive-table-cell">
                                        <span
                                        class="d-lg-none">{{'common.text_account_warranty_table_header_model'|cxTranslate}}</span>
                                        <span>{{item.model}}</span>
                                      </td>
                                      <td class="responsive-table-cell">
                                        <span
                                        class="d-lg-none">{{'common.text_account_warranty_table_header_credit_memo'|cxTranslate}}</span>
                                        <span>{{item.creditMemoNumber}}</span>
                                      </td>
                                      @if (warrantyApiData?.creditAmountVisible) {
                                        <td class="responsive-table-cell">
                                          <span class="d-lg-none">{{ 'common.text_account_warranty_table_header_credit_amount' |
                                          cxTranslate}}</span>
                                          <span>{{item.amount}}</span>
                                        </td>
                                      }
                                      <td class="responsive-table-cell">
                                        <span
                                        class="d-lg-none">{{'common.text_account_warranty_table_header_core_value'|cxTranslate}}</span>
                                        <span>{{item.coreValue}}</span>
                                      </td>
                                    </tr>
                                  }
                                </tbody>
                              }
                            </table>

                            <!-- Pagination -->
                            @if (warrantyApiData?.results) {
                              <div class="account-orderhistory-pagination warranty-pagination">
                                <div class="product__list--wrapper">
                                  <div class="pagination-bar">
                                    <div class="pagination-toolbar">
                                      <div class="row sort-refine-bar">
                                        <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 bottom-result">
                                          <div class="pagination-result">
                                            {{'common.search_page_showing_text'|cxTranslate}}
                                            {{(warrantyApiData.pagination.pageSize *
                                            warrantyApiData.pagination.currentPage)+1 }} -
                                            @if ((warrantyApiData.pagination.pageSize > warrantyApiData.pagination.totalResults)
                                              || (warrantyApiData.pagination.pageSize === warrantyApiData.pagination.totalResults)) {
                                              <span>
                                                {{warrantyApiData.pagination.totalResults}}
                                                {{'common.search_page_of_text'|cxTranslate}}
                                              {{warrantyApiData.pagination.totalResults}} </span>
                                            }
                                            @if ((warrantyApiData.pagination.pageSize *(warrantyApiData.pagination.currentPage+1) <= warrantyApiData.pagination.totalResults)&&(warrantyApiData.pagination.pageSize < warrantyApiData.pagination.totalResults)) {
                                              <span
                                                >
                                                {{warrantyApiData.pagination.pageSize*(warrantyApiData.pagination.currentPage+1)}}
                                                of
                                              {{warrantyApiData.pagination.totalResults}} </span>
                                            }
                                            @if ((warrantyApiData.pagination.pageSize *(warrantyApiData.pagination.currentPage+1) > warrantyApiData.pagination.totalResults)&&(warrantyApiData.pagination.pageSize < warrantyApiData.pagination.totalResults)) {
                                              <span
                                                >{{warrantyApiData.pagination.totalResults}}
                                                {{'common.search_page_of_text'|cxTranslate}}
                                              {{warrantyApiData.pagination.totalResults}} </span>
                                            }
                                            {{'common.search_page_result_text'|cxTranslate}}
                                          </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8 kb-pagination-right kb-pagination">
                                          <kb-pagination [pagination]="warrantyApiData?.pagination" [defaultPage]="0"
                                            (viewPageEvent)="postWarrantyData($event)">
                                          </kb-pagination>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>

                        </div>
                      </div>